"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fontFamily = `
@font-face {
  font-family: 'Termina';
  src: url('/fonts/termina/Termina-Medium.woff');
  src: url('/fonts/termina/Termina-Medium.woff') format('woff'),
  font-weight: 400;
  font-style: normal;
}

html {
    font-family: "Termina", sans-serif;
    font-size: 13px !important;
}

`;
exports.default = {
    fontFamily,
};
